import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from "react";
import { lazyImportComponent, LoadingPlaceholder } from "@sparky/framework";
const CopilotIconButton = lazyImportComponent("netsec-co-pilot", "CopilotIconButton");
function CoPilotButton() {
    return (_jsx(Suspense, { fallback: _jsx(LoadingPlaceholder, {}), children: _jsx(CopilotIconButton, { divider: true }) }));
}
export default CoPilotButton;
